<template>
<div class="chapter">
<div class="inner_page">
<a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a><a id="pv"></a><a id="pvi"></a>
<p class="center ">First Mariner Books edition 2012</p>
<div class="timebreak "> </div>
<p class="center ">Copyright © 2011 by Paul Theroux</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center ">
<a href="http://www.hmhbooks.com" target="_blank">hmhbooks.com</a>
</p>
<div class="timebreak "> </div>
<p class="center "><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Theroux, Paul.<br/>
The tao of travel : enlightenments from lives on the road / Paul Theroux.<br/>
p. cm.<br/>
Includes index.<br/>
<span class="smallcaps">ISBN</span> 978-0-547-33691-6<br/>
<span class="smallcaps">ISBN</span> 978-0-547-73737-9 (pbk.)<br/>
1. Travel—Anecdotes. 2. Travelers—Anecdotes. I. Title.<br/>
G180.T54 2011<br/>
910.4—dc22 2010042022</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-547-54919-4<br/>
v3.0620</p>
<div class="timebreak "> </div>
<p class="center ">Permissions and credits follow the index.</p>
<a id="pvii"></a>
<a id="pviii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?046bcc12